export const mapCompanyDto = (dto) => ({
    id: dto.id,
    name: dto.name,
    address: dto.address,
    comment: dto.comment,
    contactPerson: dto.contact_person,
    vatId: dto.vat_id,
    email: dto.email,
    phone: dto.phone,
});
